const reasons = ['silence','vad_no_speech','speech_without_text','signal_without_text','decode_failed','artifact_read_failed','unknown'];

export function emptyTranscriptHint(record) {
  const reason = record?.quality_diagnostics?.empty_reason;
  return reason === 'silence' ? 'overview.silentAudioHint'
    : reason === 'speech_without_text' ? 'overview.speechWithoutTextHint'
    : reason === 'decode_failed' ? 'overview.audioReadHint'
    : reason === 'artifact_read_failed' ? 'overview.resultReadHint' : 'overview.noSpeechHint';
}

export function resultQualityMeasurements(record) {
  const data = record?.quality_diagnostics || {};
  const result = { error_code: `empty_${reasons.includes(data.empty_reason) ? data.empty_reason : 'unknown'}` };
  for (const [key, low, high] of [['audio_rms_dbfs',-120,12], ['audio_peak_dbfs',-120,12],
    ['measured_seconds',0,121], ['speech_seconds',0,36000]]) {
    if (typeof data[key] === 'number' && Number.isFinite(data[key]) && data[key] >= low && data[key] <= high) result[key] = data[key];
  }
  for (const key of ['probe_complete','vad_filter_effective','vad_fallback_used','vad_fallback_attempted']) {
    if (typeof data[key] === 'boolean') result[key] = data[key];
  }
  return result;
}
